import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { Field, FieldProps, getIn } from 'formik';
import moment from 'moment';
import { SingleDatePicker, SingleDatePickerShape } from 'react-dates';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

let fieldCounter = 0;

interface DatePickerProps {
  name: string;
  label?: string;
  inputProps?: Partial<SingleDatePickerShape>;
  fieldProps?: any;
}
export class DatePicker extends Component<DatePickerProps> {
  state = {
    focused: false,
  };

  id: string = null;

  constructor(props: any) {
    super(props);
    this.id = props.id || `field_datepicker_alt_${fieldCounter++}`;
  }

  render() {
    const { name, label, inputProps = {}, fieldProps = {} } = this.props;

    return (
      <Field
        name={name}
        render={({ field, form }: FieldProps) => {
          const error = getIn(form.touched, name) && getIn(form.errors, name);

          return (
            <Form.Field error={!!error} {...fieldProps}>
              {!!label && <label htmlFor={this.id}>{label}</label>}

              <SingleDatePicker
                id={this.id}
                inputIconPosition="after"
                focused={this.state.focused}
                onFocusChange={({ focused }) => this.setState({ focused })}
                noBorder
                readOnly
                enableOutsideDays
                isOutsideRange={() => false}
                numberOfMonths={1}
                displayFormat="DD.MM.YYYY"
                placeholder={inputProps.placeholder || ''}
                {...inputProps}
                date={field.value ? moment(field.value) : null}
                onDateChange={(date) => {
                  form.setFieldValue(name, date ? date.toDate().toISOString() : date, true);
                }}
              />

              {error && (
                <span
                  style={{
                    display: 'block',
                    margin: '.28571429rem 0',
                    fontSize: '.92857143em',
                  }}
                >
                  {error}
                </span>
              )}
            </Form.Field>
          );
        }}
      />
    );
  }
}
